import { Loader } from './loader';
import { CourseCard } from './course-card';
import { TestCard } from './test-card';
import { useCourses } from '../hooks/use-course';
import { useWorkspace } from '../context/workspace-context';

export default function CourseList() {
  const { currentWorkspace } = useWorkspace();

  if (!currentWorkspace) {
    return <Loader />;
  }

  return <CourseListContent organisationId={currentWorkspace.id} />;
}

function CourseListContent({ organisationId }: { organisationId: number }) {
  const { data, isLoading, error } = useCourses(organisationId);

  if (isLoading) return <Loader />;
  if (error) return <div>Error: {error.message}</div>;

  const courses = data?.courses || [];

  return (
    <div className="grid grid-cols-1">
      <TestCard organisationId={organisationId} />
      {courses.map((course) => (
        <CourseCard key={course.course_id} course={course} />
      ))}
    </div>
  );
}
